import dayjs, {Dayjs} from 'dayjs';

import {Client} from '../../../../../types/src';

const buildRange = (end: number) => Array.from({length: Math.max(end, 0)}, (_, index) => index);

export const campaignStartTimeTooltip =
  'Campaign will wait until this date and time before it starts running. Use this if you want to delay running the campaign. Leave it empty to use the default start behavior.';

export const shouldShowCampaignStartTimeField = (client?: Client | null) => !!client?.k8s_support;

export const disablePastCampaignStartDate = (current?: Dayjs) => {
  return !!current && current.isBefore(dayjs().startOf('day'));
};

export const disablePastCampaignStartTime = (current?: Dayjs | null) => {
  const now = dayjs();

  if (!current || !current.isSame(now, 'day')) {
    return {};
  }

  const currentHour = now.hour();
  const currentMinute = now.minute();
  const currentSecond = now.second();

  return {
    disabledHours: () => buildRange(currentHour),
    disabledMinutes: (selectedHour: number) => (selectedHour === currentHour ? buildRange(currentMinute) : []),
    disabledSeconds: (selectedHour: number, selectedMinute: number) =>
      selectedHour === currentHour && selectedMinute === currentMinute ? buildRange(currentSecond) : [],
  };
};
